export default __webpack_public_path__ + "static/media/sponsor-collectif.057b1cd6.png";